// Analytics event name constants
export const ANALYTICS_EVENTS = {
  // User actions
  USER_JOINED_CHAT: 'user_joined_chat',
  USER_LEFT_CHAT: 'user_left_chat',
  REMOTE_PARTICIPANT_LEFT: 'remote_participant_left',
  CHAT_MESSAGE_SENT: 'chat_message_sent',
  
  // UI interactions
  AVATAR_CHANGED: 'avatar_changed',
  BACKGROUND_CHANGED: 'background_changed',
  MIC_TOGGLE: 'mic_toggle',
  
  // Session events
  SKIP_TO_NEXT_MATCH: 'skip_to_next_match',
  TIMER_COMPLETED: 'timer_completed',
  
  // Navigation
  PAGE_VIEW: 'page_view',
  
  // Button clicks
  BUTTON_CLICK: 'button_click',
  LOGIN_BUTTON_CLICK: 'login_button_click',
  LOGIN_SUCCESS: 'login_success',
  START_CHAT_BUTTON_CLICK: 'start_chat_button_click',
  BACK_BUTTON_CLICK: 'back_button_click',
  CONTINUE_BUTTON_CLICK: 'continue_button_click',
  AVATAR_SELECT_CLICK: 'avatar_select_click',
  GAME_BUTTON_CLICK: 'game_button_click',
  GIFT_BUTTON_CLICK: 'gift_button_click',
  BACKGROUND_BUTTON_CLICK: 'background_button_click',
  BACKGROUND_CLOSE_CLICK: 'background_close_click',
  BACKGROUND_OPTION_CLICK: 'background_option_click',
  MODAL_CLOSE_CLICK: 'modal_close_click',
  CHAT_TOGGLE_CLICK: 'chat_toggle_click',
  SEND_MESSAGE_CLICK: 'send_message_click',
  HOME_BUTTON_CLICK: 'home_button_click',
  HOME_CONFIRMATION_CLICK: 'home_confirmation_click',
  TRY_AGAIN_CLICK: 'try_again_click',
  
  // Footer/Info modals
  ABOUT_MODAL_OPEN: 'about_modal_open',
  TOS_MODAL_OPEN: 'tos_modal_open',
  PRIVACY_MODAL_OPEN: 'privacy_modal_open',
  GUIDELINES_MODAL_OPEN: 'guidelines_modal_open',
  FAQ_MODAL_OPEN: 'faq_modal_open',
  
  // Camera/Media controls
  WEBCAM_TOGGLE: 'webcam_toggle',
  CAMERA_TEST_JOIN: 'camera_test_join',
  JOIN_OR_CREATE_ROOM: 'join_or_create_room',
  
  // Reactions
  REACTIONS_BUTTON_CLICK: 'reactions_button_click',
  REACTION_SENT: 'reaction_sent',
  
  // Guest login
  GUEST_LOGIN_SUCCESS: 'guest_login_success',
  
  // Background upload
  BACKGROUND_UPLOAD_SUCCESS: 'background_upload_success',
  BACKGROUND_UPLOAD_FAILED: 'background_upload_failed',
  
  // User setup flow
  USERNAME_CREATED: 'username_created',
  PERMISSIONS_GRANTED: 'permissions_granted',
  AVATAR_SELECTED: 'avatar_selected'
};
